import { render, staticRenderFns } from "./HeatMap.vue?vue&type=template&id=9563fe1a&scoped=true&"
import script from "./HeatMap.vue?vue&type=script&lang=js&"
export * from "./HeatMap.vue?vue&type=script&lang=js&"
import style0 from "./HeatMap.vue?vue&type=style&index=0&id=9563fe1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9563fe1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9563fe1a')) {
      api.createRecord('9563fe1a', component.options)
    } else {
      api.reload('9563fe1a', component.options)
    }
    module.hot.accept("./HeatMap.vue?vue&type=template&id=9563fe1a&scoped=true&", function () {
      api.rerender('9563fe1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/HeatMap.vue"
export default component.exports